import React from "react";
import LegalLayout, { LegalH2, LegalP, LegalUL } from "./LegalLayout";

export default function ShippingPolicy() {
  return (
    <LegalLayout
      testId="shipping-policy-page"
      overline="Gear on the Way"
      title="Shipping Policy"
      updated="February 2026"
    >
      <LegalP>
        We ship anywhere in India through trusted courier partners. This policy explains our
        dispatch timelines, delivery estimates, charges, and how to track your order.
      </LegalP>

      <LegalH2>1. Processing & Dispatch</LegalH2>
      <LegalUL>
        <li>Orders placed before 2 PM IST on a business day are typically processed and dispatched within <strong>1-2 business days</strong>.</li>
        <li>Orders placed on Sundays or Indian public holidays are processed the next business day.</li>
        <li>You will receive a shipping confirmation email with the courier name and tracking number as soon as your order is dispatched.</li>
      </LegalUL>

      <LegalH2>2. Delivery Timelines</LegalH2>
      <LegalP>
        Delivery timelines vary by pincode. Approximate durations from the date of dispatch:
      </LegalP>
      <LegalUL>
        <li><strong>Metro cities</strong> (Chennai, Bengaluru, Mumbai, Delhi NCR, Hyderabad, Kolkata, Pune, Ahmedabad): 2-4 business days</li>
        <li><strong>Tier-2 cities</strong>: 4-6 business days</li>
        <li><strong>Remote / North-East / Ladakh / Andaman regions</strong>: 7-10 business days</li>
      </LegalUL>
      <LegalP>
        These are estimates provided by our courier partners and are not guaranteed. Delivery may be
        delayed by weather, natural events, regional strikes, or courier network disruptions.
      </LegalP>

      <LegalH2>3. Shipping Charges</LegalH2>
      <LegalUL>
        <li><strong>Free shipping</strong> on all prepaid orders above <strong>₹999</strong>.</li>
        <li>A flat shipping fee of <strong>₹99</strong> applies to orders under ₹999.</li>
        <li>Cash on Delivery (COD) may attract an additional handling fee of ₹49, shown at checkout.</li>
        <li>Remote pincodes may incur an additional courier surcharge, communicated before order confirmation.</li>
      </LegalUL>

      <LegalH2>4. Order Tracking</LegalH2>
      <LegalUL>
        <li>Once dispatched, you'll receive a tracking link via email and SMS.</li>
        <li>You can also view real-time status inside your <a href="/account/orders" className="text-[#D96A1B] hover:underline">Account → Orders</a> page.</li>
        <li>Tracking data may take up to 24 hours to reflect after dispatch — please allow that buffer before contacting support.</li>
      </LegalUL>

      <LegalH2>5. Courier Partners</LegalH2>
      <LegalP>
        We work with Delhivery, Shiprocket, DTDC, Blue Dart and India Post depending on your pincode
        and product size. The specific courier is assigned automatically based on the fastest &
        safest available route to your address.
      </LegalP>

      <LegalH2>6. Undelivered / Returned Shipments</LegalH2>
      <LegalUL>
        <li>Please ensure your delivery address, phone, and pincode are accurate before placing an order.</li>
        <li>If the courier is unable to reach you after 3 delivery attempts, the parcel is returned to us as "RTO" (Return to Origin).</li>
        <li>For prepaid orders returned as RTO due to no fault of ours, we will refund the order value less the actual shipping fee incurred (both ways).</li>
        <li>For COD orders returned as RTO, we reserve the right to restrict future COD orders on that phone number.</li>
      </LegalUL>

      <LegalH2>7. International Shipping</LegalH2>
      <LegalP>
        We currently ship only within India. For international enquiries, please email
        {" "}<a href="mailto:hello@mileforge.in" className="text-[#D96A1B] hover:underline">hello@mileforge.in</a>
        {" "}and we'll do our best to accommodate large custom orders.
      </LegalP>

      <LegalH2>8. Damaged in Transit</LegalH2>
      <LegalP>
        If your package arrives visibly damaged, please refuse the delivery or take clear photos
        before opening it. Notify us within 48 hours via
        {" "}<a href="mailto:hello@mileforge.in" className="text-[#D96A1B] hover:underline">hello@mileforge.in</a>
        {" "}so we can arrange a free replacement or refund. See our
        {" "}<a href="/refund-policy" className="text-[#D96A1B] hover:underline">Refund Policy</a>
        {" "}for full details.
      </LegalP>

      <LegalH2>9. Contact Support</LegalH2>
      <LegalP>
        Delivery issue or questions? Email
        {" "}<a href="mailto:hello@mileforge.in" className="text-[#D96A1B] hover:underline">hello@mileforge.in</a>
        {" "}or WhatsApp
        {" "}<a href="https://wa.me/919884041979" target="_blank" rel="noreferrer" className="text-[#D96A1B] hover:underline">+91 98840 41979</a>
        {" "}with your order number and we'll respond within one business day.
      </LegalP>
    </LegalLayout>
  );
}
